/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconDescription/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconDescription({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconDescription",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconDescription.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z1ghLEy': alignSelf,'--mt-2-Z1ghLEy': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1ghLEy': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1ghLEy': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1ghLEy': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1ghLEy': opacity,'--w-10-Z1ghLEy': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1ghLEy': typeof height === 'number' ? `${height}px` : height,'--a-7-Z1ghLEy': isAnimated ? animation : "none",'--sd-8-Z1ghLEy': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1ghLEy': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconDescription.SvgPath"
  data-view-path={viewPath}
 d="M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"
 style={{'--f-12-Z1ghLEy': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}